import { createReducer } from "@reduxjs/toolkit";
import { PACKAGE_LOADING, PACKAGE_ERROR, PACKAGE_LIST } from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const packageReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(PACKAGE_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(PACKAGE_ERROR, (state, { payload }) => {
      state.error = payload;
    })
    .addCase(PACKAGE_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default packageReducer;
